var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _templateObject = _taggedTemplateLiteralLoose(['\n  padding-left: 45px;\n  text-align: center;\n  font-size: 14px;\n  font-weigth: bold;\n  cursor: pointer;\n'], ['\n  padding-left: 45px;\n  text-align: center;\n  font-size: 14px;\n  font-weigth: bold;\n  cursor: pointer;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  cursor: pointer;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  min-height: 30px;\n  padding-top: 15px;\n  background-repeat: no-repeat;\n  background-position: left;\n  background-image: url(\n    ', '\n  );\n   \n  &:hover {\n    background-image: url(\'http://www.hype.it/Chat/images/newstyle/', '_active_hover.png\')\n  }\n'], ['\n  cursor: pointer;\n  margin-top: 5px;\n  margin-bottom: 5px;\n  min-height: 30px;\n  padding-top: 15px;\n  background-repeat: no-repeat;\n  background-position: left;\n  background-image: url(\n    ', '\n  );\n   \n  &:hover {\n    background-image: url(\'http://www.hype.it/Chat/images/newstyle/', '_active_hover.png\')\n  }\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  width: 100%;\n  margin-top: 10px;\n'], ['\n  width: 100%;\n  margin-top: 10px;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';

var options = [{ value: '1', text: 'Ottimo', icon: 'icn_40x40_feedback_entusiasta' }, { value: '2', text: 'Buono', icon: 'icn_40x40_feedback_soddisfatto' }, { value: '3', text: 'Sufficiente', icon: 'icn_40x40_feedback_neutrale' }, { value: '4', text: 'Scarso', icon: 'icn_40x40_feedback_deluso' }, { value: '5', text: 'Non adeguato', icon: 'icn_40x40_feedback_irritato' }];

var Span = styled.label(_templateObject);

var Div = function Div(_ref) {
  var text = _ref.text,
      onChange = _ref.onChange,
      className = _ref.className;
  return React.createElement(
    'div',
    { className: className, onClick: onChange },
    React.createElement(
      Span,
      null,
      text
    )
  );
};

var Wrapper = styled(Div)(_templateObject2, function (props) {
  return props.selected ? '\'http://www.hype.it/Chat/images/newstyle/' + props.icon + '_active_hover.png\'' : '\'http://www.hype.it/Chat/images/newstyle/' + props.icon + '_normal.png\'';
}, function (props) {
  return props.icon;
});

var Container = styled.div(_templateObject3);

var RatingRadio = function RatingRadio(_ref2) {
  var selected = _ref2.selected,
      handleChange = _ref2.handleChange;
  return React.createElement(
    Container,
    null,
    options.map(function (option) {
      return React.createElement(Wrapper, _extends({
        key: option.value,
        selected: selected === option.value
      }, option, {
        onChange: function onChange() {
          return handleChange(option.value);
        }
      }));
    })
  );
};

export default RatingRadio;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/rating-radio.js
// module id = 892
// module chunks = 1